import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FaTwitter, FaDownload, FaLink, FaTimes, FaCloudUploadAlt, FaCoins, FaSignOutAlt, FaBars, FaMagic, FaFilm, FaFileAlt } from "react-icons/fa";
import { SiDiscord } from "react-icons/si";
import '../App.css';
import { Link, useNavigate } from "react-router-dom";
import { QRCodeSVG } from 'qrcode.react';
import { optimizeVideo, batchLoadVideos, optimizeTickerCSS } from '../optimize';

function HomePage() {
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [instructions, setInstructions] = useState("");
  const [duration, setDuration] = useState("5");
  const [aspectRatio, setAspectRatio] = useState("1:1");
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [uploadMethod, setUploadMethod] = useState("file"); // 'file' or 'url'
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [processingMessage, setProcessingMessage] = useState(null);
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [userCredits, setUserCredits] = useState(null);
  const [userPremiumCredits, setUserPremiumCredits] = useState(null);
  const [usePremiumCredits, setUsePremiumCredits] = useState(false);
  const [creditsNeeded, setCreditsNeeded] = useState(1);
  const [showCheckCredits, setShowCheckCredits] = useState(false);
  const [showNoCreditsPopup, setShowNoCreditsPopup] = useState(false);
  const [processingVideoId, setProcessingVideoId] = useState(null);
  const [isPolling, setIsPolling] = useState(false);
  const [galleryVideos, setGalleryVideos] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [showCreditsModal, setShowCreditsModal] = useState(false);
  const [showCreditsDropdown, setShowCreditsDropdown] = useState(false);
  const [showBuyCreditsModal, setShowBuyCreditsModal] = useState(false);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [btcAmount, setBtcAmount] = useState('');
  const [btcPrice, setBtcPrice] = useState(null);
  const [usdEquivalent, setUsdEquivalent] = useState(0);
  const [creditsEquivalent, setCreditsEquivalent] = useState(0);
  const [transactionId, setTransactionId] = useState('');
  const [transactionSubmitted, setTransactionSubmitted] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const btcAddress = "bc1qufljwgvmrmfyhd7x75tg0mkdfgh6274la0yya6";
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("image-to-video"); // "image-to-video" or "text-to-video"
  const [loadingMessages, setLoadingMessages] = useState([
    "Please wait while the magic happens",
    // "Why you dont grab a bag of Pepodins while you wait!",
    "Waiting for AI to stop overthinking",
    "Only the worthy find Valhalla",
    "also Troy loves feet",
    "FIAT is a Shitcoin",
    "AI is questioning its career choices",
    "Whats Brown and Sticky? a Stick",
    "AI just saw your request and said 'bruh'",
    "Nearly there",
    "Ssshh… the AI is concentrating",
    "Waiting for the blockchain to confirm your patience",
    "Teaching robots to draw without thumbs",
    "Bribing pixels to arrange themselves nicely",
    "Congratulations! You've unlocked a new level of waiting",
    "Calculating the meaning of life, memes, and everything",
    "Your Animation would've been right-clicked by now",
    "This loading screen is not an investment advice",
    "AI is just making sure you really want this",
    "Sacrificing a JPEG to the algorithm gods",
    "Downloading more RAM to process your request",
    "Plot twist: The AI is also waiting for something to happen"
  ]);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  // New state variables for optimized gallery loading
  const [visibleGalleryVideos, setVisibleGalleryVideos] = useState([]);
  const [isGalleryInitialized, setIsGalleryInitialized] = useState(false);
  const [loadedVideoCount, setLoadedVideoCount] = useState(0);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) { // 10MB limit
        setError("File size too large. Please upload an image under 10MB.");
        return;
      }
      try {
        await validateImage(file);
        setImage(file);
        setPreviewUrl(URL.createObjectURL(file));
        setError(null);
      } catch (error) {
        setError(error.message);
        setImage(null);
        setPreviewUrl(null);
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      try {
        await validateImage(file);
        setImage(file);
        setPreviewUrl(URL.createObjectURL(file));
        setError(null);
      } catch (error) {
        setError(error);
        setImage(null);
        setPreviewUrl(null);
      }
    }
  };

  const handleUrlSubmit = async () => {
    if (!imageUrl) return;
    if (!email) {
      setError("Please enter your email address");
      return;
    }
    
    setError(null);
    setLoading(true);

    try {
      await validateUrlImage(imageUrl);
      const response = await axios.post(
        "https://frogland.onrender.com/convert-image-to-video",
        {
          imageUrl,
          email,
          instructions,
          duration,
          aspectRatio,
          isPrivate: isPrivate
        }
      );

      // Reset form and show success modal
      setImageUrl("");
      setInstructions("");
      setProcessingMessage({
        title: "Animation Processing Started! 🎨",
        message: "We've started processing your animation. Please check your email for updates. We'll send you a notification once it's ready!",
        email: email
      });
      setShowModal(true);
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      setError(error.response?.data?.details || error instanceof Error ? error.message : "Error converting image to video. Please try a different image URL.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!email) {
      setError("Please enter your email address");
      return;
    }

    // Double-check premium credits if the option is selected
    if (usePremiumCredits && (!userPremiumCredits || userPremiumCredits < creditsNeeded)) {
      setError("Please Contact support at Telegram: https://discord.gg/frogland-io");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const formData = new FormData();
      if (uploadMethod === 'file') {
        formData.append("image", image);
      } else {
        formData.append("imageUrl", imageUrl);
      }
      formData.append("email", email);
      formData.append("instructions", instructions);
      formData.append("duration", duration);
      formData.append("aspectRatio", aspectRatio);
      formData.append("isPrivate", isPrivate.toString());
      formData.append("usePremiumCredits", usePremiumCredits.toString());

      const response = await axios.post(
        "https://frogland.onrender.com/convert-image-to-video",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === 'success') {
        // Reset form
        setImage(null);
        setImageUrl("");
        setPreviewUrl(null);
        setInstructions("");
        
        // Store the video ID for polling
        if (response.data.videoId) {
          setProcessingVideoId(response.data.videoId);
          setIsPolling(true);
        }
        
        // Show success modal
        setProcessingMessage({
          title: "Animation Processing Started! 🎨",
          message: "We've started processing your animation. You'll be automatically redirected when it's ready. We'll also send you an email notification once it's complete!",
          email: email
        });
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      
      // Check if the error is related to insufficient credits
      if (error.response?.data?.error === "Insufficient credits") {
        setShowNoCreditsPopup(true);
      } else {
        setError(error.response?.data?.details || "Error processing image. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(videoUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'animated-Image.mp4';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      alert('Failed to download video');
    }
  };

  const handleShare = (platform) => {
    const text = "Check out my animated Image created with Image Animator! 🎨✨";
    const url = videoUrl;
    switch (platform) {
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`);
        break;
      case 'discord':
        navigator.clipboard.writeText(url);
        alert('Video URL copied! You can now paste it in Discord');
        break;
      default:
        break;
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(videoUrl);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const copyBtcAddress = async () => {
    try {
      await navigator.clipboard.writeText(btcAddress);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const validateImage = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(img.src);
        const minDimension = Math.min(img.width, img.height);
        if (minDimension < 300) {
          reject("Image must be at least 300px on its shortest side");
        } else if (file.size > 10 * 1024 * 1024) {
          reject("Image must be less than 10MB");
        } else {
          resolve();
        }
      };
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        reject('Invalid image file');
      };
    });
  };

  const validateUrlImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        const minDimension = Math.min(img.width, img.height);
        if (minDimension < 300) {
          reject("Image must be at least 300px on its shortest side");
        } else {
          resolve();
        }
      };
      img.onerror = () => {
        reject('Invalid image URL');
      };
    });
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    localStorage.setItem('userEmail', newEmail);
  };

  const handleShowCreditsModal = () => {
    if (!email || !email.includes('@') || !email.includes('.')) {
      setShowCreditsModal(true);
    } else {
      handleCheckCredits();
    }
  };

  const handleCheckCredits = async () => {
    try {
      const response = await axios.get(`https://frogland.onrender.com/user/credits/${email}`);
      setUserCredits(response.data.credits);
      setUserPremiumCredits(response.data.premiumCredits || 0);
      setCreditsNeeded(duration === "5" ? 1 : 2);
      
      // Show no credits popup if user has 0 credits and 0 premium credits
      if (response.data.credits === 0 && (!response.data.premiumCredits || response.data.premiumCredits === 0)) {
        setShowNoCreditsPopup(true);
      }
    } catch (error) {
      console.error('Error fetching credits:', error);
    }
  };

  const handleSignOut = () => {
    // Clear user data
    setUserCredits(null);
    setEmail("");
    localStorage.removeItem('userEmail');
    setShowCreditsDropdown(false);
  };

  useEffect(() => {
    if (imageUrl) {
      validateUrlImage(imageUrl);
    }
  }, [imageUrl]);

  useEffect(() => {
    // Reset error when no credits popup is closed
    if (!showNoCreditsPopup) {
      setError(null);
    }
  }, [showNoCreditsPopup]);

  useEffect(() => {
    // Load saved email from localStorage
    const savedEmail = localStorage.getItem('userEmail');
    if (savedEmail) {
      setEmail(savedEmail);
      setShowCheckCredits(savedEmail.includes('@') && savedEmail.includes('.'));
    }
  }, []);

  useEffect(() => {
    setCreditsNeeded(duration === "5" ? 1 : 2);
  }, [duration]);

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  // Polling mechanism to check video status
  useEffect(() => {
    let interval;
    
    const checkVideoStatus = async () => {
      if (!processingVideoId) return;
      
      try {
        const response = await axios.get(`https://frogland.onrender.com/video/${processingVideoId}`);
        
        // If video is ready
        if (response.data && response.data.videoUrl) {
          setVideoUrl(response.data.videoUrl);
          setProcessingMessage(null);
          setIsPolling(false);
          clearInterval(interval);
          
          // Redirect to the VideoView page
          navigate(`/video/${processingVideoId}`);
        }
      } catch (error) {
        console.error("Error checking video status:", error);
        // If there's an error, we continue polling
      }
    };
    
    if (processingVideoId && isPolling) {
      // Check immediately
      checkVideoStatus();
      
      // Then check every 10 seconds
      interval = setInterval(checkVideoStatus, 10000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [processingVideoId, isPolling, navigate]);

  // Fetch gallery videos on component mount
  useEffect(() => {
    const fetchGalleryVideos = async () => {
      setGalleryLoading(true);
      try {
        const response = await axios.get('https://frogland.onrender.com/public-animations?limit=12');
        console.log('Gallery videos data:', response.data);
        
        // Ensure all videos have the .mp4 extension
        const processedVideos = response.data.map(video => ({
          ...video,
          videoUrl: video.videoUrl.endsWith('.mp4') ? video.videoUrl : `${video.videoUrl}.mp4`,
          isLoaded: false
        }));
        
        setGalleryVideos(processedVideos);
        
        // Initialize with just the first 4 videos to improve initial loading performance
        if (processedVideos.length > 0) {
          setVisibleGalleryVideos(processedVideos.slice(0, 4));
          setIsGalleryInitialized(true);
        }
      } catch (error) {
        console.error('Error fetching gallery videos:', error);
      } finally {
        setGalleryLoading(false);
      }
    };

    fetchGalleryVideos();
  }, []);

  // Load more videos gradually after initial render
  useEffect(() => {
    if (isGalleryInitialized && galleryVideos.length > 0 && loadedVideoCount < galleryVideos.length) {
      const batchSize = 2; // Load 2 videos at a time
      const nextBatchIndex = Math.min(loadedVideoCount + batchSize, galleryVideos.length);
      
      const timer = setTimeout(() => {
        setVisibleGalleryVideos(prev => [
          ...prev,
          ...galleryVideos.slice(loadedVideoCount, nextBatchIndex)
        ]);
        setLoadedVideoCount(nextBatchIndex);
      }, 300); // Add a small delay between batches
      
      return () => clearTimeout(timer);
    }
  }, [isGalleryInitialized, galleryVideos, loadedVideoCount]);

  // Fetch BTC price when the modal opens
  useEffect(() => {
    if (showBuyCreditsModal) {
      fetchBtcPrice();
    }
  }, [showBuyCreditsModal]);
  
  // Function to fetch current BTC price
  const fetchBtcPrice = async () => {
    try {
      const response = await axios.get('https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd');
      setBtcPrice(response.data.bitcoin.usd);
    } catch (error) {
      console.error('Error fetching BTC price:', error);
      setBtcPrice(30000); // Fallback price if API fails
    }
  };
  
  // Calculate USD and credits equivalent when BTC amount changes
  useEffect(() => {
    if (btcPrice && btcAmount) {
      const btcValue = parseFloat(btcAmount) || 0;
      const usdValue = btcValue * btcPrice;
      setUsdEquivalent(usdValue.toFixed(2));
      
      // Round up to nearest integer and add 1 more credit
      setCreditsEquivalent(Math.floor(usdValue) + 1);
    } else {
      setUsdEquivalent(0);
      setCreditsEquivalent(0);
    }
  }, [btcAmount, btcPrice]);
  
  // Handle BTC amount input change
  const handleBtcAmountChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setBtcAmount(value);
    }
  };

  // Handle transaction ID input change
  const handleTransactionIdChange = (e) => {
    setTransactionId(e.target.value);
  };
  
  // Handle proceeding to transaction ID modal
  const handleProceedToTransaction = () => {
    setShowBuyCreditsModal(false);
    setShowTransactionModal(true);
  };
  
  // Handle submitting the transaction
  const handleSubmitTransaction = async () => {
    setIsSubmitting(true);
    try {
      const response = await axios.post('https://frogland.onrender.com/transaction', {
        email,
        transactionId,
        btcAmount,
        usdAmount: usdEquivalent,
        creditsAmount: creditsEquivalent
      });

      if (response.data.success) {
        setTransactionSubmitted(true);
        setShowTransactionModal(false);
        setShowSuccessModal(true);
        
        // Reset form fields for next transaction
        setTransactionId('');
        setBtcAmount('');
        setUsdEquivalent(0);
        setCreditsEquivalent(0);
      }
    } catch (error) {
      console.error('Transaction submission error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Update the isValidEmail function
  const isValidEmail = (email) => {
    // More precise email validation regex that requires proper domain extension
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailRegex.test(email) && email.includes('.') && email.split('.').pop().length >= 2;
  };

  // Update the video ticker rendering with lazy loading and optimization
  const renderTickerVideo = (video, index, position) => {
    // Use a lazy loading approach with onLoadedData
    return (
      <div 
        className="ticker-item" 
        key={`${position}-${video.videoId}-${index}`}
        onClick={() => navigate(`/video/${video.videoId}`)}
        style={{ cursor: 'pointer' }}
      >
        <div className="ticker-video-container">
          <video 
            muted 
            autoPlay={video.isLoaded} 
            loop 
            playsInline
            src={video.videoUrl}
            onLoadedData={(e) => {
              // Mark video as loaded and enable autoplay
              if (!video.isLoaded) {
                video.isLoaded = true;
                e.target.play().catch(err => console.log('Autoplay prevented:', err));
              }
            }}
            poster={video.thumbnailUrl || ''}
            loading="lazy"
          />
          <div className="ticker-overlay">
            <span className="prompt-text">{video.instructions || 'View Animation & Prompt'}</span>
          </div>
        </div>
      </div>
    );
  };

  // Update the handleTextToVideoSubmit function to use the correct endpoint
  const handleTextToVideoSubmit = async () => {
    if (!email) {
      setError("Please enter your email address");
      return;
    }
    
    if (!instructions || instructions.trim() === '') {
      setError("Please provide a prompt for your video");
      return;
    }

    // Double-check premium credits if the option is selected
    if (usePremiumCredits && (!userPremiumCredits || userPremiumCredits < creditsNeeded)) {
      setError("Please contact support at Telegram: https://discord.gg/frogland-io");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const response = await axios.post(
        "https://frogland.onrender.com/text-to-video",
        {
          email,
          instructions,
          duration,
          isPrivate,
          usePremiumCredits
        }
      );

      if (response.data.status === 'success') {
        // Reset form
        setInstructions("");
        
        // Store the video ID for polling
        if (response.data.videoId) {
          setProcessingVideoId(response.data.videoId);
          setIsPolling(true);
        }
        
        // Show success modal
        setProcessingMessage({
          title: "Video Generation Started! 🎬",
          message: "We've started processing your video. You'll be automatically redirected when it's ready. We'll also send you an email notification once it's complete!",
          email: email
        });
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      
      // Check if the error is related to insufficient credits
      if (error.response?.data?.error === "Insufficient credits") {
        setShowNoCreditsPopup(true);
      } else {
        setError(error.response?.data?.details || "Error generating video. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let interval;
    
    if (showModal) {
      // Start with the first message
      setCurrentMessageIndex(0);
      
      // Then show random messages after the first one
      interval = setInterval(() => {
        // Generate a random index between 1 and the last index
        const randomIndex = Math.floor(Math.random() * (loadingMessages.length - 1)) + 1;
        setCurrentMessageIndex(randomIndex);
      }, 3000); // Change message every 3 seconds
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showModal, loadingMessages.length]);

  // Add this function to handle closing the success modal
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    setTransactionSubmitted(false); // Reset for next transaction
  };

  return (
    <div className="container">
      <div className="navbar">
        <div className="mobile-menu-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <FaBars />
        </div>
        
        <div className={`nav-tabs ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link 
            to="/" 
            className="nav-tab active"
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/my-animations" 
            className="nav-tab"
            onClick={() => setMobileMenuOpen(false)}
          >
            My Animations
          </Link>
        </div>
        
        <div className="top-right-credits">
          {userCredits !== null ? (
            <div className="credits-wrapper">
              <div 
                className="credits-display"
                onClick={() => setShowCreditsDropdown(!showCreditsDropdown)}
              >
                <FaCoins className="credits-icon" />
                <span className="credit-value">
                  {userCredits} <span className="credit-label">Free</span>
                </span>
                {userPremiumCredits > 0 && (
                  <span className="credit-value premium">
                    {userPremiumCredits} <span className="credit-label">Premium</span>
                  </span>
                )}
              </div>
              
              {showCreditsDropdown && (
                <div className="credits-dropdown">
                  <div className="dropdown-email">{email}</div>
                  <div className="credits-details">
                    <div className="credit-item">
                      <span>Free Credits:</span>
                      <span>{userCredits}</span>
                    </div>
                    <div className="credit-item">
                      <span>Premium Credits:</span>
                      <span>{userPremiumCredits || 0}</span>
                    </div>
                  </div>
                  <button className="buy-credits-button" onClick={() => {
                    setShowBuyCreditsModal(true);
                    setShowCreditsDropdown(false);
                  }}>
                    <FaCoins /> Buy Credits
                  </button>
                  <button className="signout-button" onClick={handleSignOut}>
                    <FaSignOutAlt /> Sign Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="credits-buttons">
              <button 
                onClick={handleShowCreditsModal}
                className="show-credits-button"
              >
                <FaCoins className="credits-icon" />
                <span>Show Credits</span>
              </button>
              <button 
                onClick={() => setShowBuyCreditsModal(true)}
                className="buy-credits-button"
              >
                <FaCoins className="credits-icon" />
                <span>Buy Credits</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Credits Modal */}
      {showCreditsModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={() => setShowCreditsModal(false)}>
              <FaTimes />
            </button>
            <h2>Check Your Credits</h2>
            <div className="modal-body">
              <p>Enter your email to check available credits:</p>
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="you@example.com"
                className="text-input"
              />
              <button
                style={{ marginTop: '10px' }} 
                onClick={() => {
                  handleCheckCredits();
                  setShowCreditsModal(false);
                }}
                className="convert-button"
                disabled={!email || !email.includes('@') || !email.includes('.')}
              >
                Check Credits
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Buy Credits Modal - Step 1 */}
      {showBuyCreditsModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={() => setShowBuyCreditsModal(false)}>
              <FaTimes />
            </button>
            <h2>Buy Credits with Bitcoin</h2>
            <div className="modal-body">
              {/* Always show email input */}
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="you@example.com"
                  className="text-input"
                />
                <span className="input-hint">Required for credit allocation</span>
                {email && !isValidEmail(email) && (
                  <span className="validation-message">Please enter a valid email address</span>
                )}
              </div>

              {btcPrice ? (
                <div className="btc-converter">
                  <p className="current-rate">Current Rate: 1 BTC = ${btcPrice.toLocaleString()} USD</p>
                  
                  <div className="converter-input">
                    <label>Payment in BTC</label>
                    <input
                      type="text"
                      value={btcAmount}
                      onChange={handleBtcAmountChange}
                      placeholder="0.001"
                      className="text-input"
                    />
                  </div>
                  
                  <div className="conversion-results">
                    <div className="conversion-item">
                      <span>USD Equivalent:</span>
                      <span className="conversion-value">${usdEquivalent}</span>
                    </div>
                    <div className="conversion-item">
                      <span>Credits to Receive:</span>
                      <span className="conversion-value">{creditsEquivalent}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="loading-price">
                  <p>Loading current BTC price...</p>
                  <div className="spinner"></div>
                </div>
              )}
              
              <p>Send Bitcoin to the following address:</p>
              <div className="crypto-address">
                <div className="address-display">
                  {btcAddress}
                </div>
                <button 
                  className={`share-button copy ${copySuccess ? 'success' : ''}`}
                  onClick={copyBtcAddress}
                >
                  {copySuccess ? 'Copied!' : 'Copy'}
                </button>
              </div>
              <div className="qr-container">
                <QRCodeSVG
                  value={`bitcoin:${btcAddress}${btcAmount ? `?amount=${btcAmount}` : ''}`}
                  size={200}
                  bgColor={"#ffffff"}
                  fgColor={"#000000"}
                  level={"L"}
                  includeMargin={false}
                />
              </div>
              <p className="payment-info">
                After sending payment, click Next to enter your transaction ID.
              </p>
              
              <button 
                className="convert-button"
                onClick={handleProceedToTransaction}
                disabled={!btcAmount || parseFloat(btcAmount) <= 0 || !isValidEmail(email)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Transaction ID Modal - Step 2 */}
      {showTransactionModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={() => setShowTransactionModal(false)}>
              <FaTimes />
            </button>
            <h2>Confirm Your Payment</h2>
            <div className="modal-body">
              <p>Please enter the transaction ID from your Bitcoin payment:</p>
              
              <div className="transaction-form">
                <div className="form-group">
                  <label>Transaction ID</label>
                  <input
                    type="text"
                    value={transactionId}
                    onChange={handleTransactionIdChange}
                    placeholder="Enter your Bitcoin transaction ID"
                    className="text-input"
                    disabled={transactionSubmitted || isSubmitting}
                  />
                </div>
                
                <div className="payment-summary">
                  <h3>Payment Summary</h3>
                  <div className="summary-item">
                    <span>Amount Paid:</span>
                    <span>{btcAmount} BTC</span>
                  </div>
                  <div className="summary-item">
                    <span>USD Equivalent:</span>
                    <span>${usdEquivalent}</span>
                  </div>
                  <div className="summary-item">
                    <span>Credits to Receive:</span>
                    <span>{creditsEquivalent}</span>
                  </div>
                  <div className="summary-item">
                    <span>Email:</span>
                    <span>{email}</span>
                  </div>
                </div>
                
                <button 
                  className="convert-button"
                  onClick={handleSubmitTransaction}
                  disabled={!transactionId || transactionSubmitted || isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span>Submitting...</span>
                      <div className="spinner small"></div>
                    </>
                  ) : transactionSubmitted ? (
                    <>
                      <span>Processing</span>
                      <div className="spinner small"></div>
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>
                
                {transactionSubmitted && (
                  <div className="success-message">
                    <p>Thank you! Your transaction has been submitted for processing. Credits will be added to your account once confirmed.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="video-ticker-container top">
        {galleryLoading ? (
          <div className="gallery-loading">
            <div className="spinner"></div>
            <p>Loading gallery...</p>
          </div>
        ) : visibleGalleryVideos.length > 0 ? (
          <>
            <div className="ticker-title">Featured Animations</div>
            <div className="video-ticker">
              <div className="ticker-row ticker-row-1">
                {[...visibleGalleryVideos, ...visibleGalleryVideos].map((video, index) => 
                  renderTickerVideo(video, index, 'top')
                )}
              </div>
            </div>
          </>
        ) : null}
      </div>

      <div className="main-content">
        <div className="tab-toggle" style={{ marginLeft: 0, alignSelf: 'flex-start' }}>
          <a 
            href="#" 
            className={`tab-button ${activeTab === 'image-to-video' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab('image-to-video');
            }}
          >
            Image to Video
          </a>
          <a 
            href="#" 
            className={`tab-button ${activeTab === 'text-to-video' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab('text-to-video');
            }}
          >
            Text to Video
          </a>
        </div>

        {activeTab === 'image-to-video' ? (
          <>
            <div className="upload-method-toggle">
              <button 
                className={`method-button ${uploadMethod === 'file' ? 'active' : ''}`}
                onClick={() => setUploadMethod('file')}
              >
                Upload File
              </button>
              <button 
                className={`method-button ${uploadMethod === 'url' ? 'active' : ''}`}
                onClick={() => setUploadMethod('url')}
              >
                Image URL
              </button>
            </div>

            <div className="file-upload-container">
              {uploadMethod === 'file' ? (
                <label 
                  className="file-label"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <input
                    type="file"
                    className="file-input"
                    onChange={handleImageChange}
                    accept="image/*"
                  />
                  {previewUrl ? (
                    <img src={previewUrl} alt="Preview" className="image-preview" />
                  ) : (
                    <div className="upload-placeholder">
                      <FaCloudUploadAlt className="upload-icon" />
                      <p>Drag & drop your image here or click to browse</p>
                      <p className="supported-formats">
                        Supported formats: <strong>PNG, JPG, WEBP</strong> (Max 10MB)
                      </p>
                    </div>
                  )}
                </label>
              ) : (
                <div className="url-input-container">
                  <input
                    type="url"
                    className="url-input"
                    placeholder="Paste image URL here"
                    value={imageUrl}
                    onChange={(e) => setImageUrl(e.target.value)}
                  />
                  {imageUrl && (
                    <div className="url-preview">
                      <img 
                        src={imageUrl} 
                        alt="URL Preview"
                        className={error ? 'error' : ''}
                        onError={() => setError("Invalid image URL")}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="text-to-video-container">
            <div className="text-prompt-container">
              <div className="text-prompt-icon">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <FaFileAlt style={{ marginRight: '10px' }} />
                  <span style={{ fontSize: '24px', margin: '0 5px' }}>→</span>
                  <FaFilm style={{ marginLeft: '10px' }} />
                </div>
              </div>
              <h3 style={{ color: 'var(--bitcoin-orange)', marginBottom: '15px' }}>Text to Video Generation</h3>
              <p>Enter a detailed description below to create your video from text. Be specific about scenes, characters, actions, and style for best results.</p>
              <p style={{ fontSize: '0.9em', opacity: '0.8', marginTop: '10px' }}>
              </p>
            </div>
          </div>
        )}

        <div className="options-grid">
          <div className="input-group">
            <label className="input-label">
              {activeTab === 'image-to-video' 
                ? 'Enter your Prompt:' 
                : 'Describe your video:'}
            </label>
            <textarea
              className="text-input"
              value={instructions}
              onChange={(e) => setInstructions(e.target.value)}
              placeholder={activeTab === 'image-to-video'
                ? "(Brief description of the image you upload) and (Briefly describe a simple action of how you want your image animated)"
                : "Describe in detail what you want to see in your video. Be specific about scenes, actions, characters, etc."
              }
            />
          </div>

          <div className="input-group">
            <label className="input-label">Email</label>
            <div className="email-input-container">
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="you@example.com"
                required
                className="text-input"
              />
            </div>
            <span className="input-hint">We'll email you when your {activeTab === 'image-to-video' ? 'animation' : 'video'} is ready</span>
          </div>

          <div className="input-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isPrivate}
                onChange={(e) => setIsPrivate(e.target.checked)}
                className="checkbox-input"
              />
              <span className="checkbox-text">Make this {activeTab === 'image-to-video' ? 'animation' : 'video'} private</span>
            </label>
            <span className="checkbox-hint">Private {activeTab === 'image-to-video' ? 'animations' : 'videos'} won't appear in the public gallery</span>
          </div>

          <button 
            className="share-button download"
            onClick={activeTab === 'image-to-video' ? handleSubmit : handleTextToVideoSubmit}
            disabled={loading || 
              (activeTab === 'image-to-video' && (!image && !imageUrl)) || 
              (activeTab === 'text-to-video' && !instructions) || 
              !email}
          >
            {loading ? 'Sending to Processing...' : `Create ${activeTab === 'image-to-video' ? 'Animation' : 'Video'}`}
          </button>
        </div>

        {error && (
          <div className="error-message">
            <FaTimes className="error-icon" />
            {error}
          </div>
        )}

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setShowModal(false)}>
                <FaTimes />
              </button>
              <div className="processing-message">
                <h2>{processingMessage.title}</h2>
                <div className="processing-details">
                  <div className="loading-message-container">
                    <p className="loading-fun-message">{loadingMessages[currentMessageIndex]}</p>
                  </div>
                  <p>{processingMessage.message}</p>
                  <div className="email-notification">
                    <small>Email will be sent to: {processingMessage.email}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showNoCreditsPopup && (
          <div className="modal-overlay" onClick={() => setShowNoCreditsPopup(false)}>
            <div className="modal-content no-credits-modal" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setShowNoCreditsPopup(false)}>
                <FaTimes />
              </button>
              <div className="no-credits-message">
                <h2>No Credits Available</h2>
                <p>
                No Credits Available

Alas, you don't have any credits, for Free Credits, pick up a <a href="https://opensea.io/collection/notorious-frogs/" target="_blank" rel="noopener noreferrer">Notorious Frog</a> and join the <a href="https://discord.gg/frogland-io" target="_blank" rel="noopener noreferrer">Discord</a> to request your free credits. 
<br/>
If for whatever bizarre reason you dont want a Notorious Frog and a bunch if free credits, you are welcome to purchase Credits directly with Bitcoin, with other currencies on the way. 
                </p>
                {/* <button 
                  className="convert-button buy-now-button"
                  onClick={() => {
                    setShowNoCreditsPopup(false);
                    setShowBuyCreditsModal(true);
                  }}
                >
                  Buy Credits Now
                </button> */}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="video-ticker-container bottom">
        {!galleryLoading && visibleGalleryVideos.length > 0 && (
          <>
            <div className="ticker-title">More Inspirations</div>
            <div className="video-ticker">
              <div className="ticker-row ticker-row-2">
                {[...visibleGalleryVideos.slice().reverse(), ...visibleGalleryVideos.slice().reverse()].map((video, index) => 
                  renderTickerVideo(video, index, 'bottom')
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={handleCloseSuccessModal}>
              <FaTimes />
            </button>
            <h2>Transaction Submitted</h2>
            <div className="modal-body">
              <p>Thank you! Your transaction has been submitted for processing.</p>
              <p>Credits will be added to your account once the transaction is approved by an admin.</p>
            </div>
          </div>
        </div>
      )}

      {mobileMenuOpen && (
        <div 
          className="mobile-menu-overlay active" 
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}
    </div>
  );
}

export default HomePage; 


// https://image-animator-ai.onrender.co0m